import React, {useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import EllipsesControl from '../../../../EllipsesControl/EllipsesControl';
import Utility from '../../../../../../util/utilityfunctions';
import {useUserPreferences} from '../../../../../../util/customHooks';
import {normalize} from '../../../../../../util/utils';
import CreateEditEntityModal from '../../../../../Common/EntityCrud/CreateEditEntityModal';
import {updateFormBodyRelatedObject} from '../../../../../../actions/FormData/formdataactions';
import {entities, OperationTypes} from '../../../../../../util/uiconstants';

export const ITRiskRelatedObject = (props) => {
	const {data, isTopLevel, bodyId, isSnapshotView} = props;
	const currentLevel = isTopLevel ? 1 : data?.level;

	const dispatch = useDispatch();

	const userPreferences = useUserPreferences();

	const [showModal, setShowModal] = useState(false);

	const onClick = useCallback(() => {
		if (!isSnapshotView) {
			setShowModal(true);
		}
	}, [isSnapshotView]);

	const itRiskSelector = (state) => {
		return {
			...data,
			itRiskName: data.entityName,
			itProcessId: data.parentEntityId
		};
	};

	const itProcessesSelector = (state) => {
		const itProcess = {
			id: data.parentEntityId,
			itProcessName: data.parentEntityName
		};

		return normalize([itProcess], undefined);
	};

	const handleOnEntityModified = useCallback(
		(itRisk) => {
			const actionPayload = {
				...itRisk,
				bodyId: bodyId,
				entityId: entities.ItRisk,
				entityUId: itRisk.id,
				entityName: itRisk.itRiskName
			};
			return dispatch(updateFormBodyRelatedObject(actionPayload, OperationTypes.update));
		},
		[bodyId]
	);

	return (
		<StyledITRiskRelatedObject className={`ITRiskRelatedObject entity-content entity-content-level-${currentLevel}`}>
			<section
				className={`entity-content-main ITProcessRelatedObjectWrapper ${Utility.getClasstoDisableADCLink(
					userPreferences,
					isSnapshotView
				)}`}
				onClick={onClick}
			>
				<EllipsesControl content={data?.entityName} tooltip={data?.entityName} noOfLines={2} />
			</section>
			{!isSnapshotView && (
				<CreateEditEntityModal
					entityType={data.entityId}
					entityId={data?.entityUId}
					entitySelector={itRiskSelector}
					parentEntitiesSelector={itProcessesSelector}
					showCreateEditEntityModal={showModal}
					setShowCreateEditEntityModal={setShowModal}
					onEntityModified={handleOnEntityModified}
				/>
			)}
		</StyledITRiskRelatedObject>
	);
};

const StyledITRiskRelatedObject = styled.section`
	&.entity-content {
		&.entity-content-level-2 {
			margin-left: var(--px-20);
			border-bottom: var(--px-1) solid var(--neutrals-200);
			padding: var(--px-5) 0 !important;
			&:last-child {
				border: 0;
			}
		}
		&.ITRiskRelatedObject {
			.entity-content-main {
				display: flex;
				width: 100% !important;
				max-width: calc(100% - var(--px-450)) !important;
				text-decoration: none !important;
				&:hover {
					text-decoration: underline !important;
				}
				.ellipses {
					width: auto !important;
					max-width: 100% !important;
					margin-left: var(--px-20) !important;
				}
				.RiskRelatedIcon {
					display: inline-flex;
					.RiskRelatedIconText {
						font-size: var(--px-12);
						margin-top: calc(var(--px-2) * -1);
						color: var(--neutrals-900);
						font-weight: bold;
					}
					.motif-icon {
						display: inline-flex;
					}
				}
			}
		}
	}
`;

export default ITRiskRelatedObject;
